import script from "./TRProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./TRProgress.vue?vue&type=script&setup=true&lang=js"

import "./TRProgress.vue?vue&type=style&index=0&id=5b568e8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b568e8d"]])

export default __exports__